import {
  StyledInputWrapper,
  StyledInputLabel,
  StyledFormItemField,
  StyledDropdownWithInputField,
} from "./style";
import type { DropdownFieldProps } from "./interfaces";
import { useState, useEffect } from "react";

export const SearchableSelectWithInput = (props: DropdownFieldProps) => {
  const [selectedValue, setSelectedValue] = useState(props.value);

  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  const handleChange = (value: string | number | unknown) => {
    if (typeof value == "string" || typeof value == "number") {
      setSelectedValue(value);
    }

    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <StyledInputWrapper style={props.style} hidden={props.hidden}>
      {props.label ? <StyledInputLabel>{props.label}</StyledInputLabel> : null}
      <StyledFormItemField name={props.name} rules={props.rules}>
        <StyledDropdownWithInputField
          allowClear
          options={props.options}
          placeholder={props.placeholder}
          isEditable={props.isEditable}
          suffixIcon={props.isEditable ? undefined : null}
          value={selectedValue}
          onChange={handleChange}
          mode={"tags"}
          maxCount={1}
          tagRender={(val) => (
            <div style={{ marginRight: "8px" }}>{val.label}</div>
          )}
          filterOption={(input, option) =>
            (option?.label as string).includes(input)
          }
        />
      </StyledFormItemField>
    </StyledInputWrapper>
  );
};
